import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
// import { requestForToken, onMessageListener, messaging } from "./firebase";
// Components
import LoginPage from './Pages/Login/login';
import Forgotpassword from './Pages/Login/forgotPassword';
import ResetPassword from './Pages/Login/resetPassword';
import Dashboard from './Pages/counsellor/Dashboard';
import AssessmentDetails from './Pages/counsellor/AssessmentDetails';
import Assessments from './Pages/Assessments/Assessments';
import CaseHistory from './Pages/patient/CaseHistory';
import ViewCaseHistory from './Pages/patient/ViewCaseHistory';
import Profile from './Pages/navbar/Profile';
import MessagingPage from './Pages/counsellor/Messaging/MessagingPage';
import CounsellorPage from './Pages/counsellor/CounsellorPage';
import ViewallAppointments from './Pages/counsellor/ViewallAppointments';
import AppointmentsResult from './Pages/counsellor/AppointmentRecords';
import MyAvailability from './Pages/counsellor/MyAvailability';
import Viewcase from './Pages/patient/Viewcase';
import PublicAssessment from './Pages/patient/PublicAssessment';
// import ViewCaseReturning from './Pages/patient/ViewCaseReturning';
// Layout
function AppLayout() {
  // const [initialRoute, setInitialRoute] = useState(null); // null = still checking
  const location = useLocation();

  const user = localStorage.getItem("user");

  const isLoggedIn = user;

  return (
    <>

      <Routes>
        {/* 🟢 Public routes – accessible to everyone */}
        <Route path="/" element={isLoggedIn ? <Navigate to={"/dashboard"} replace /> : <LoginPage />} />
        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/assessment/:customerId/:assessmentKey" element={<PublicAssessment />} />

        <Route
          path="/dashboard"
          element={isLoggedIn ? <Dashboard /> : <Navigate to="/" replace />}
        />

        <Route
          path="/messaging"
          element={isLoggedIn ? <MessagingPage /> : <Navigate to="/" replace />}
        />
       

        <Route
          path="/profile"
          element={isLoggedIn ? <Profile /> : <Navigate to="/" replace />}
        />

        <Route
          path="/assessments"
          element={isLoggedIn ? <Assessments /> : <Navigate to="/" replace />}
        />
        <Route
          path="/assessment-details"
          element={isLoggedIn ? <AssessmentDetails /> : <Navigate to="/" replace />}
        />
        <Route
          path="/counsellors"
          element={isLoggedIn ? <CounsellorPage /> : <Navigate to="/" replace />}
        />

        <Route
          path="/all-appointments"
          element={isLoggedIn ? <ViewallAppointments /> : <Navigate to="/" replace />}
        />
        <Route
          path="/appointments-results"
          element={isLoggedIn ? <AppointmentsResult /> : <Navigate to="/" replace />}
        />
        <Route
          path="/my-availability"
          element={isLoggedIn ? <MyAvailability /> : <Navigate to="/" replace />}
        />
        <Route
          path="/patient/case-history/:patientId/:appointmentId"
          element={isLoggedIn ? <CaseHistory /> : <Navigate to="/" replace />}
        />
        <Route
          path="/patient/view/:patientId/:appointmentId"
          element={isLoggedIn ? <ViewCaseHistory /> : <Navigate to="/" replace />}
        />

         <Route
        path="/patient/view-case/:patientId/:appointmentId"
        element={
          isLoggedIn
            ? <Viewcase />
            : <Navigate to="/" replace />
        }
      />
      {/* <Route
        path="patient/view-case-returning/:patientId/:appointmentId"
        element={
          isLoggedIn
            ? <ViewCaseReturning />
            : <Navigate to="/" replace />
        }
      /> */}
      

        {/* 🔴 Default fallback – if user tries an invalid path */}
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <Navigate to={"/dashboard"} replace />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>

    </>
  );
}

// Main App
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppLayout />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
